import React, { useState } from "react";
import { Customer } from "@/api/customers";
import RigthPanel from "@/ui-controls/RigthPanel";
import AddButton from "@/ui-controls/AddButton";
import NewCustomerForm from "@/components/customers/NewCustomerForm";

interface Props {
  onSave: (customer: Customer) => any;
  disabled?: boolean;
}

const NewCustomer = (props: Props) => {
  const openPanel = () => {
    setIPanelOpen(true);
  };

  const onCloseNewAppPanel = () => {
    setIPanelOpen(false);
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  return (
    <>
      <AddButton text="Customer" onClick={openPanel} disabled={props.disabled} />
      <RigthPanel
        header="Add New Customer"
        isOpen={isPanelOpen}
        dismissPanel={onCloseNewAppPanel}
        childComponent={NewCustomerForm}
        childProps={{
          onClose: () => onCloseNewAppPanel(),
          onSave: (customer: Customer) => {
            props.onSave(customer);
            onCloseNewAppPanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default NewCustomer;
